<template>
  <svg width="32"
       height="32"
       viewBox="0 0 32 32"
       fill="none"
       xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_7618_19511)">
      <path d="M2.81982 7.79707C2.81982 6.80296 3.62571 5.99707 4.61982 5.99707H12.4299C12.9468 5.99707 13.4437 6.19724 13.8163 6.5556L16.6734 9.3036C17.0926 9.70676 17.6516 9.93195 18.2331 9.93195H25.9715C26.9656 9.93195 27.7715 10.7378 27.7715 11.7319V19.908L24.2069 29.884H6.81982C4.61068 29.884 2.81982 28.0932 2.81982 25.884V7.79707Z"
            fill="url(#paint0_linear_7618_19511)"
      />
      <path d="M2.81982 7.79707C2.81982 6.80296 3.62571 5.99707 4.61982 5.99707H12.4299C12.9468 5.99707 13.4437 6.19724 13.8163 6.5556L16.6734 9.3036C17.0926 9.70676 17.6516 9.93195 18.2331 9.93195H25.9715C26.9656 9.93195 27.7715 10.7378 27.7715 11.7319V19.908L24.2069 29.884H6.81982C4.61068 29.884 2.81982 28.0932 2.81982 25.884V7.79707Z"
            fill="url(#paint1_linear_7618_19511)"
      />
      <path d="M2.81982 7.79707C2.81982 6.80296 3.62571 5.99707 4.61982 5.99707H12.4299C12.9468 5.99707 13.4437 6.19724 13.8163 6.5556L16.6734 9.3036C17.0926 9.70676 17.6516 9.93195 18.2331 9.93195H25.9715C26.9656 9.93195 27.7715 10.7378 27.7715 11.7319V19.908L24.2069 29.884H6.81982C4.61068 29.884 2.81982 28.0932 2.81982 25.884V7.79707Z"
            fill="url(#paint2_linear_7618_19511)"
      />
      <path d="M2.81982 7.79707C2.81982 6.80296 3.62571 5.99707 4.61982 5.99707H12.4299C12.9468 5.99707 13.4437 6.19724 13.8163 6.5556L16.6734 9.3036C17.0926 9.70676 17.6516 9.93195 18.2331 9.93195H25.9715C26.9656 9.93195 27.7715 10.7378 27.7715 11.7319V19.908L24.2069 29.884H6.81982C4.61068 29.884 2.81982 28.0932 2.81982 25.884V7.79707Z"
            fill="url(#paint3_radial_7618_19511)"
      />
      <path d="M2.81982 7.79707C2.81982 6.80296 3.62571 5.99707 4.61982 5.99707H12.4299C12.9468 5.99707 13.4437 6.19724 13.8163 6.5556L16.6734 9.3036C17.0926 9.70676 17.6516 9.93195 18.2331 9.93195H25.9715C26.9656 9.93195 27.7715 10.7378 27.7715 11.7319V19.908L24.2069 29.884H6.81982C4.61068 29.884 2.81982 28.0932 2.81982 25.884V7.79707Z"
            fill="url(#paint4_radial_7618_19511)"
      />
      <path d="M2.81982 7.79707C2.81982 6.80296 3.62571 5.99707 4.61982 5.99707H12.4299C12.9468 5.99707 13.4437 6.19724 13.8163 6.5556L16.6734 9.3036C17.0926 9.70676 17.6516 9.93195 18.2331 9.93195H25.9715C26.9656 9.93195 27.7715 10.7378 27.7715 11.7319V19.908L24.2069 29.884H6.81982C4.61068 29.884 2.81982 28.0932 2.81982 25.884V7.79707Z"
            fill="url(#paint5_radial_7618_19511)"
            fill-opacity="0.61"
      />
      <path d="M2.81982 7.79707C2.81982 6.80296 3.62571 5.99707 4.61982 5.99707H12.4299C12.9468 5.99707 13.4437 6.19724 13.8163 6.5556L16.6734 9.3036C17.0926 9.70676 17.6516 9.93195 18.2331 9.93195H25.9715C26.9656 9.93195 27.7715 10.7378 27.7715 11.7319V19.908L24.2069 29.884H6.81982C4.61068 29.884 2.81982 28.0932 2.81982 25.884V7.79707Z"
            fill="url(#paint6_radial_7618_19511)"
            fill-opacity="0.61"
      />
      <path d="M2.81982 7.79707C2.81982 6.80296 3.62571 5.99707 4.61982 5.99707H12.4299C12.9468 5.99707 13.4437 6.19724 13.8163 6.5556L16.6734 9.3036C17.0926 9.70676 17.6516 9.93195 18.2331 9.93195H25.9715C26.9656 9.93195 27.7715 10.7378 27.7715 11.7319V19.908L24.2069 29.884H6.81982C4.61068 29.884 2.81982 28.0932 2.81982 25.884V7.79707Z"
            fill="url(#paint7_radial_7618_19511)"
            fill-opacity="0.61"
      />
      <path d="M2.81982 7.79707C2.81982 6.80296 3.62571 5.99707 4.61982 5.99707H12.4299C12.9468 5.99707 13.4437 6.19724 13.8163 6.5556L16.6734 9.3036C17.0926 9.70676 17.6516 9.93195 18.2331 9.93195H25.9715C26.9656 9.93195 27.7715 10.7378 27.7715 11.7319V19.908L24.2069 29.884H6.81982C4.61068 29.884 2.81982 28.0932 2.81982 25.884V7.79707Z"
            fill="url(#paint8_radial_7618_19511)"
            fill-opacity="0.61"
      />
      <path d="M2.81982 7.79707C2.81982 6.80296 3.62571 5.99707 4.61982 5.99707H12.4299C12.9468 5.99707 13.4437 6.19724 13.8163 6.5556L16.6734 9.3036C17.0926 9.70676 17.6516 9.93195 18.2331 9.93195H25.9715C26.9656 9.93195 27.7715 10.7378 27.7715 11.7319V19.908L24.2069 29.884H6.81982C4.61068 29.884 2.81982 28.0932 2.81982 25.884V7.79707Z"
            fill="url(#paint9_radial_7618_19511)"
      />
      <path d="M2.81982 7.79707C2.81982 6.80296 3.62571 5.99707 4.61982 5.99707H12.4299C12.9468 5.99707 13.4437 6.19724 13.8163 6.5556L16.6734 9.3036C17.0926 9.70676 17.6516 9.93195 18.2331 9.93195H25.9715C26.9656 9.93195 27.7715 10.7378 27.7715 11.7319V19.908L24.2069 29.884H6.81982C4.61068 29.884 2.81982 28.0932 2.81982 25.884V7.79707Z"
            fill="url(#paint10_radial_7618_19511)"
      />
      <path d="M2.81982 7.79707C2.81982 6.80296 3.62571 5.99707 4.61982 5.99707H12.4299C12.9468 5.99707 13.4437 6.19724 13.8163 6.5556L16.6734 9.3036C17.0926 9.70676 17.6516 9.93195 18.2331 9.93195H25.9715C26.9656 9.93195 27.7715 10.7378 27.7715 11.7319V19.908L24.2069 29.884H6.81982C4.61068 29.884 2.81982 28.0932 2.81982 25.884V7.79707Z"
            fill="url(#paint11_radial_7618_19511)"
      />
      <path d="M2.81982 7.79707C2.81982 6.80296 3.62571 5.99707 4.61982 5.99707H12.4299C12.9468 5.99707 13.4437 6.19724 13.8163 6.5556L16.6734 9.3036C17.0926 9.70676 17.6516 9.93195 18.2331 9.93195H25.9715C26.9656 9.93195 27.7715 10.7378 27.7715 11.7319V19.908L24.2069 29.884H6.81982C4.61068 29.884 2.81982 28.0932 2.81982 25.884V7.79707Z"
            fill="url(#paint12_radial_7618_19511)"
      />
      <path d="M2.81982 7.79707C2.81982 6.80296 3.62571 5.99707 4.61982 5.99707H12.4299C12.9468 5.99707 13.4437 6.19724 13.8163 6.5556L16.6734 9.3036C17.0926 9.70676 17.6516 9.93195 18.2331 9.93195H25.9715C26.9656 9.93195 27.7715 10.7378 27.7715 11.7319V19.908L24.2069 29.884H6.81982C4.61068 29.884 2.81982 28.0932 2.81982 25.884V7.79707Z"
            fill="url(#paint13_radial_7618_19511)"
      />
      <path d="M2.81982 7.79707C2.81982 6.80296 3.62571 5.99707 4.61982 5.99707H12.4299C12.9468 5.99707 13.4437 6.19724 13.8163 6.5556L16.6734 9.3036C17.0926 9.70676 17.6516 9.93195 18.2331 9.93195H25.9715C26.9656 9.93195 27.7715 10.7378 27.7715 11.7319V19.908L24.2069 29.884H6.81982C4.61068 29.884 2.81982 28.0932 2.81982 25.884V7.79707Z"
            fill="url(#paint14_linear_7618_19511)"
            fill-opacity="0.3"
      />
      <path d="M2.81982 7.79707C2.81982 6.80296 3.62571 5.99707 4.61982 5.99707H12.4299C12.9468 5.99707 13.4437 6.19724 13.8163 6.5556L16.6734 9.3036C17.0926 9.70676 17.6516 9.93195 18.2331 9.93195H25.9715C26.9656 9.93195 27.7715 10.7378 27.7715 11.7319V19.908L24.2069 29.884H6.81982C4.61068 29.884 2.81982 28.0932 2.81982 25.884V7.79707Z"
            fill="url(#paint15_linear_7618_19511)"
            fill-opacity="0.3"
      />
      <path d="M2.81982 7.79707C2.81982 6.80296 3.62571 5.99707 4.61982 5.99707H12.4299C12.9468 5.99707 13.4437 6.19724 13.8163 6.5556L16.6734 9.3036C17.0926 9.70676 17.6516 9.93195 18.2331 9.93195H25.9715C26.9656 9.93195 27.7715 10.7378 27.7715 11.7319V19.908L24.2069 29.884H6.81982C4.61068 29.884 2.81982 28.0932 2.81982 25.884V7.79707Z"
            fill="url(#paint16_radial_7618_19511)"
            fill-opacity="0.3"
      />
      <path d="M2.81982 7.79707C2.81982 6.80296 3.62571 5.99707 4.61982 5.99707H12.4299C12.9468 5.99707 13.4437 6.19724 13.8163 6.5556L16.6734 9.3036C17.0926 9.70676 17.6516 9.93195 18.2331 9.93195H25.9715C26.9656 9.93195 27.7715 10.7378 27.7715 11.7319V19.908L24.2069 29.884H6.81982C4.61068 29.884 2.81982 28.0932 2.81982 25.884V7.79707Z"
            fill="url(#paint17_radial_7618_19511)"
            fill-opacity="0.3"
      />
      <path d="M2.81982 7.79707C2.81982 6.80296 3.62571 5.99707 4.61982 5.99707H12.4299C12.9468 5.99707 13.4437 6.19724 13.8163 6.5556L16.6734 9.3036C17.0926 9.70676 17.6516 9.93195 18.2331 9.93195H25.9715C26.9656 9.93195 27.7715 10.7378 27.7715 11.7319V19.908L24.2069 29.884H6.81982C4.61068 29.884 2.81982 28.0932 2.81982 25.884V7.79707Z"
            fill="url(#paint18_linear_7618_19511)"
            fill-opacity="0.3"
      />
      <path d="M2.81982 7.79707C2.81982 6.80296 3.62571 5.99707 4.61982 5.99707H12.4299C12.9468 5.99707 13.4437 6.19724 13.8163 6.5556L16.6734 9.3036C17.0926 9.70676 17.6516 9.93195 18.2331 9.93195H25.9715C26.9656 9.93195 27.7715 10.7378 27.7715 11.7319V19.908L24.2069 29.884H6.81982C4.61068 29.884 2.81982 28.0932 2.81982 25.884V7.79707Z"
            fill="url(#paint19_linear_7618_19511)"
      />
      <path d="M2.81982 7.79707C2.81982 6.80296 3.62571 5.99707 4.61982 5.99707H12.4299C12.9468 5.99707 13.4437 6.19724 13.8163 6.5556L16.6734 9.3036C17.0926 9.70676 17.6516 9.93195 18.2331 9.93195H25.9715C26.9656 9.93195 27.7715 10.7378 27.7715 11.7319V19.908L24.2069 29.884H6.81982C4.61068 29.884 2.81982 28.0932 2.81982 25.884V7.79707Z"
            fill="url(#paint20_radial_7618_19511)"
      />
      <path d="M2.81982 7.79707C2.81982 6.80296 3.62571 5.99707 4.61982 5.99707H12.4299C12.9468 5.99707 13.4437 6.19724 13.8163 6.5556L16.6734 9.3036C17.0926 9.70676 17.6516 9.93195 18.2331 9.93195H25.9715C26.9656 9.93195 27.7715 10.7378 27.7715 11.7319V19.908L24.2069 29.884H6.81982C4.61068 29.884 2.81982 28.0932 2.81982 25.884V7.79707Z"
            fill="url(#paint21_radial_7618_19511)"
      />
      <path d="M8.30005 15.4886C8.87274 13.904 10.377 12.8481 12.0619 12.8481L28.8638 12.8482C30.1483 12.8482 31.0627 14.0963 30.6754 15.321L26.5118 28.4868C26.2488 29.3185 25.4772 29.8838 24.6049 29.8838L6.8197 29.8838L6.80853 29.8838C6.00946 29.8816 5.2655 29.6451 4.64172 29.2394L4.63727 29.2366C4.26245 28.9921 3.93121 28.6865 3.65759 28.3339C3.53333 28.1737 3.42096 28.0038 3.32178 27.8255C3.69397 27.798 3.88776 27.6138 3.98163 27.4372L8.30005 15.4886Z"
            fill="url(#paint22_linear_7618_19511)"
      />
      <path d="M8.30005 15.4886C8.87274 13.904 10.377 12.8481 12.0619 12.8481L28.8638 12.8482C30.1483 12.8482 31.0627 14.0963 30.6754 15.321L26.5118 28.4868C26.2488 29.3185 25.4772 29.8838 24.6049 29.8838L6.8197 29.8838L6.80853 29.8838C6.00946 29.8816 5.2655 29.6451 4.64172 29.2394L4.63727 29.2366C4.26245 28.9921 3.93121 28.6865 3.65759 28.3339C3.53333 28.1737 3.42096 28.0038 3.32178 27.8255C3.69397 27.798 3.88776 27.6138 3.98163 27.4372L8.30005 15.4886Z"
            fill="url(#paint23_linear_7618_19511)"
      />
      <path d="M8.30005 15.4886C8.87274 13.904 10.377 12.8481 12.0619 12.8481L28.8638 12.8482C30.1483 12.8482 31.0627 14.0963 30.6754 15.321L26.5118 28.4868C26.2488 29.3185 25.4772 29.8838 24.6049 29.8838L6.8197 29.8838L6.80853 29.8838C6.00946 29.8816 5.2655 29.6451 4.64172 29.2394L4.63727 29.2366C4.26245 28.9921 3.93121 28.6865 3.65759 28.3339C3.53333 28.1737 3.42096 28.0038 3.32178 27.8255C3.69397 27.798 3.88776 27.6138 3.98163 27.4372L8.30005 15.4886Z"
            fill="url(#paint24_linear_7618_19511)"
            fill-opacity="0.6"
      />
      <path d="M8.30005 15.4886C8.87274 13.904 10.377 12.8481 12.0619 12.8481L28.8638 12.8482C30.1483 12.8482 31.0627 14.0963 30.6754 15.321L26.5118 28.4868C26.2488 29.3185 25.4772 29.8838 24.6049 29.8838L6.8197 29.8838L6.80853 29.8838C6.00946 29.8816 5.2655 29.6451 4.64172 29.2394L4.63727 29.2366C4.26245 28.9921 3.93121 28.6865 3.65759 28.3339C3.53333 28.1737 3.42096 28.0038 3.32178 27.8255C3.69397 27.798 3.88776 27.6138 3.98163 27.4372L8.30005 15.4886Z"
            fill="url(#paint25_linear_7618_19511)"
            fill-opacity="0.83"
      />
      <path d="M8.30005 15.4886C8.87274 13.904 10.377 12.8481 12.0619 12.8481L28.8638 12.8482C30.1483 12.8482 31.0627 14.0963 30.6754 15.321L26.5118 28.4868C26.2488 29.3185 25.4772 29.8838 24.6049 29.8838L6.8197 29.8838L6.80853 29.8838C6.00946 29.8816 5.2655 29.6451 4.64172 29.2394L4.63727 29.2366C4.26245 28.9921 3.93121 28.6865 3.65759 28.3339C3.53333 28.1737 3.42096 28.0038 3.32178 27.8255C3.69397 27.798 3.88776 27.6138 3.98163 27.4372L8.30005 15.4886Z"
            fill="url(#paint26_linear_7618_19511)"
            fill-opacity="0.83"
      />
      <path d="M8.30005 15.4886C8.87274 13.904 10.377 12.8481 12.0619 12.8481L28.8638 12.8482C30.1483 12.8482 31.0627 14.0963 30.6754 15.321L26.5118 28.4868C26.2488 29.3185 25.4772 29.8838 24.6049 29.8838L6.8197 29.8838L6.80853 29.8838C6.00946 29.8816 5.2655 29.6451 4.64172 29.2394L4.63727 29.2366C4.26245 28.9921 3.93121 28.6865 3.65759 28.3339C3.53333 28.1737 3.42096 28.0038 3.32178 27.8255C3.69397 27.798 3.88776 27.6138 3.98163 27.4372L8.30005 15.4886Z"
            fill="url(#paint27_linear_7618_19511)"
            fill-opacity="0.83"
      />
      <path d="M8.30005 15.4886C8.87274 13.904 10.377 12.8481 12.0619 12.8481L28.8638 12.8482C30.1483 12.8482 31.0627 14.0963 30.6754 15.321L26.5118 28.4868C26.2488 29.3185 25.4772 29.8838 24.6049 29.8838L6.8197 29.8838L6.80853 29.8838C6.00946 29.8816 5.2655 29.6451 4.64172 29.2394L4.63727 29.2366C4.26245 28.9921 3.93121 28.6865 3.65759 28.3339C3.53333 28.1737 3.42096 28.0038 3.32178 27.8255C3.69397 27.798 3.88776 27.6138 3.98163 27.4372L8.30005 15.4886Z"
            fill="url(#paint28_linear_7618_19511)"
      />
      <path d="M8.30005 15.4886C8.87274 13.904 10.377 12.8481 12.0619 12.8481L28.8638 12.8482C30.1483 12.8482 31.0627 14.0963 30.6754 15.321L26.5118 28.4868C26.2488 29.3185 25.4772 29.8838 24.6049 29.8838L6.8197 29.8838L6.80853 29.8838C6.00946 29.8816 5.2655 29.6451 4.64172 29.2394L4.63727 29.2366C4.26245 28.9921 3.93121 28.6865 3.65759 28.3339C3.53333 28.1737 3.42096 28.0038 3.32178 27.8255C3.69397 27.798 3.88776 27.6138 3.98163 27.4372L8.30005 15.4886Z"
            fill="url(#paint29_linear_7618_19511)"
      />
    </g>
    <defs>
      <linearGradient id="paint0_linear_7618_19511"
                      x1="7.08826"
                      y1="6.68771"
                      x2="9.90076"
                      y2="16.8127"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFD052" />
        <stop offset="1"
              stop-color="#FFBD41"
        />
      </linearGradient>
      <linearGradient id="paint1_linear_7618_19511"
                      x1="2.84375"
                      y1="19.7271"
                      x2="3.21067"
                      y2="19.7271"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#EEA850" />
        <stop offset="1"
              stop-color="#EEA850"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint2_linear_7618_19511"
                      x1="7.2269"
                      y1="5.87061"
                      x2="7.2269"
                      y2="6.3905"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#EEA850" />
        <stop offset="1"
              stop-color="#EEA850"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint3_radial_7618_19511"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(13.8804 5.80788) rotate(51.0769) scale(4.76564 0.747622)"
      >
        <stop stop-color="#EEA850" />
        <stop offset="1"
              stop-color="#EEA850"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint4_radial_7618_19511"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(13.8804 5.80788) rotate(51.0769) scale(4.76564 0.747622)"
      >
        <stop stop-color="#EEA850" />
        <stop offset="1"
              stop-color="#EEA850"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint5_radial_7618_19511"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(16.3082 8.90784) rotate(44.4244) scale(1.17149 0.18378)"
      >
        <stop stop-color="#EEA850" />
        <stop offset="1"
              stop-color="#EEA850"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint6_radial_7618_19511"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(13.5 6.16915) rotate(30.8378) scale(1.3025 0.785543)"
      >
        <stop stop-color="#EEA850" />
        <stop offset="1"
              stop-color="#EEA850"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint7_radial_7618_19511"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(2.45502 6.50654) rotate(-10.4792) scale(2.80115 0.509813)"
      >
        <stop stop-color="#EEA850" />
        <stop offset="1"
              stop-color="#EEA850"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint8_radial_7618_19511"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(2.81982 7.04298) rotate(-40.9982) scale(1.59429 0.624549)"
      >
        <stop stop-color="#EEA850" />
        <stop offset="1"
              stop-color="#EEA850"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint9_radial_7618_19511"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(19.7284 9.57304) rotate(90) scale(0.675345 3.44303)"
      >
        <stop stop-color="#EEA850" />
        <stop offset="1"
              stop-color="#EEA850"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint10_radial_7618_19511"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(23.4165 9.71397) rotate(90) scale(0.442441 2.25564)"
      >
        <stop stop-color="#EEA850" />
        <stop offset="1"
              stop-color="#EEA850"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint11_radial_7618_19511"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(21.9054 9.69543) rotate(90) scale(0.509107 2.59552)"
      >
        <stop stop-color="#EEA850" />
        <stop offset="1"
              stop-color="#EEA850"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint12_radial_7618_19511"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(27.9056 12.0912) rotate(-180) scale(0.370866 1.89074)"
      >
        <stop stop-color="#EEA850" />
        <stop offset="1"
              stop-color="#EEA850"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint13_radial_7618_19511"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(27.8532 10.6164) rotate(131.186) scale(0.672784 3.42997)"
      >
        <stop stop-color="#EEA850" />
        <stop offset="1"
              stop-color="#EEA850"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint14_linear_7618_19511"
                      x1="8.70402"
                      y1="5.99707"
                      x2="8.70402"
                      y2="6.54605"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFD75C" />
        <stop offset="1"
              stop-color="#FFD75C"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint15_linear_7618_19511"
                      x1="2.81982"
                      y1="10.0878"
                      x2="3.47272"
                      y2="10.0878"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFD75C" />
        <stop offset="1"
              stop-color="#FFD75C"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint16_radial_7618_19511"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(14.7694 7.43809) rotate(44.7335) scale(2.3569 4.30642)"
      >
        <stop stop-color="#FFD75C" />
        <stop offset="1"
              stop-color="#FFC75C"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint17_radial_7618_19511"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(18.2126 10.1819) rotate(-1.14725) scale(6.96065 12.7182)"
      >
        <stop stop-color="#FFD55C" />
        <stop offset="1"
              stop-color="#FFC75C"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint18_linear_7618_19511"
                      x1="27.7715"
                      y1="12.9488"
                      x2="27.2535"
                      y2="12.9488"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFD55C" />
        <stop offset="1"
              stop-color="#FFC75C"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint19_linear_7618_19511"
                      x1="15.2956"
                      y1="28.6535"
                      x2="15.2956"
                      y2="14.1902"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.182692"
              stop-color="#FCA23D"
        />
        <stop offset="0.826923"
              stop-color="#FCA23D"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint20_radial_7618_19511"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(11.0259 17.021) rotate(-52.125) scale(5.21145 5.44373)"
      >
        <stop offset="0.182692"
              stop-color="#FCA23D"
        />
        <stop offset="0.826923"
              stop-color="#FCA23D"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint21_radial_7618_19511"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(18.0483 14.4863) rotate(-90) scale(3.28263 14.5433)"
      >
        <stop offset="0.182692"
              stop-color="#FCA23D"
        />
        <stop offset="0.746836"
              stop-color="#FCA23D"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint22_linear_7618_19511"
                      x1="17.0435"
                      y1="12.8481"
                      x2="17.0435"
                      y2="29.8838"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFDF54" />
        <stop offset="1"
              stop-color="#FFBA5F"
        />
      </linearGradient>
      <linearGradient id="paint23_linear_7618_19511"
                      x1="7.48828"
                      y1="18.2734"
                      x2="7.80038"
                      y2="18.3869"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFC449" />
        <stop offset="1"
              stop-color="#FFC449"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint24_linear_7618_19511"
                      x1="9.68562"
                      y1="13.8516"
                      x2="10.0643"
                      y2="14.4185"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFC449" />
        <stop offset="1"
              stop-color="#FFC449"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint25_linear_7618_19511"
                      x1="17.0435"
                      y1="12.8481"
                      x2="17.0435"
                      y2="13.6629"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFC449" />
        <stop offset="1"
              stop-color="#FFC449"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint26_linear_7618_19511"
                      x1="29.2124"
                      y1="22.451"
                      x2="27.8127"
                      y2="22.1818"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFC449" />
        <stop offset="1"
              stop-color="#FFC449"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint27_linear_7618_19511"
                      x1="31.3118"
                      y1="14.6723"
                      x2="29.966"
                      y2="15.1568"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFC449" />
        <stop offset="1"
              stop-color="#FFC449"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint28_linear_7618_19511"
                      x1="17.0435"
                      y1="12.8481"
                      x2="17.0435"
                      y2="13"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFE04A" />
        <stop offset="1"
              stop-color="#FFE04A"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint29_linear_7618_19511"
                      x1="17.0435"
                      y1="12.8481"
                      x2="17.0435"
                      y2="13"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFE04A" />
        <stop offset="1"
              stop-color="#FFE04A"
              stop-opacity="0"
        />
      </linearGradient>
      <clipPath id="clip0_7618_19511">
        <rect width="32"
              height="32"
              fill="#FFFFFF"
        />
      </clipPath>
    </defs>
  </svg>
</template>
